import { getSettings } from "../../api/settingsApi";
import { useQuery } from "@tanstack/react-query";
import React from "react";

export interface TabItem {
  key: string;
  label: string;
  icon?: React.ReactNode;
  count?: number;
}

interface TabNavigationProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tabKey: string) => void;
  className?: string;
}

export function TabNavigation({
  tabs,
  activeTab,
  onTabChange,
  className = "",
}: TabNavigationProps) {
  const settingsQuery = useQuery({
    queryKey: ["/settings"],
    queryFn: getSettings,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: 10 * 60 * 1000,
  });

  const tabColor = settingsQuery?.data?.data?.appearance?.primaryColor;
  return (
    <div className={`border-b border-gray-200 ${className}`}>
      <nav className="-mb-px flex space-x-8">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 ${
              activeTab === tab.key
                ? "border-b-2"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
            style={
              activeTab === tab.key
                ? { borderColor: tabColor, color: tabColor }
                : {}
            }
          >
            {tab.icon && <span className="shrink-0">{tab.icon}</span>}
            <span className="flex items-center space-x-1">
              <span>{tab.label}</span>
              {tab.count !== undefined && (
                <span
                  className={`ml-1 ${
                    activeTab === tab.key ? "text-bits-blue" : "text-gray-400"
                  }`}
                >
                  ({tab.count})
                </span>
              )}
            </span>
          </button>
        ))}
      </nav>
    </div>
  );
}
